var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMutation)?[_vm._t("default",null,{loading:_vm.loading,mutate:_vm.mutate,errors:_vm.errors})]:[_vm._t("default",null,{loading:_vm.loading,data:_vm.data,errors:_vm.errors})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }